import { render, staticRenderFns } from "./badge.vue?vue&type=template&id=7f7ffd0e&"
import script from "./badge.vue?vue&type=script&lang=js&"
export * from "./badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f7ffd0e')) {
      api.createRecord('7f7ffd0e', component.options)
    } else {
      api.reload('7f7ffd0e', component.options)
    }
    module.hot.accept("./badge.vue?vue&type=template&id=7f7ffd0e&", function () {
      api.rerender('7f7ffd0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/badge/src/badge.vue"
export default component.exports